// extracted by mini-css-extract-plugin
export default {"formButton":"ButtonSmall_formButton__-FHDg","formButtonRed":"ButtonSmall_formButtonRed__pPKRq"};